/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

#card-participants {
  div.MuiFormGroup-root.symptoms-list div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: variables.$gap-between-lists;
    align-items: flex-end;
    label {
      width: 16%;
    }
  }
}
